import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const commandsApi = createApi({
    reducerPath: "commandsApi",
    tagTypes: ["DeviceCommands", "GroupCommands"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        getDeviceCommands: rtkClient.getDeviceCommands(builder),
        createDeviceCommand: rtkClient.createDeviceCommand(builder),
        deleteDeviceCommand: rtkClient.deleteDeviceCommand(builder),
        getGroupCommands: rtkClient.getGroupCommands(builder),
        createGroupCommand: rtkClient.createGroupCommand(builder),
        deleteGroupCommand: rtkClient.deleteGroupCommand(builder),
    }),
});

export const {
    useCreateDeviceCommandMutation,
    useCreateGroupCommandMutation,
    useDeleteDeviceCommandMutation,
    useDeleteGroupCommandMutation,
    useGetDeviceCommandsQuery,
    useGetGroupCommandsQuery,
} = commandsApi;
